import ZendeskWebWidget from './ZendeskWebWidget';
import { ZENDESK_WEB_WIDGET_TYPES } from '../zendeskConstants';
import { appHistoryReplaceWithSearchParams } from "../../../app/appHistory";
import { IConversationField } from "../Zendesk";

// https://developer.zendesk.com/api-reference/widget-messaging/introduction/
class ZendeskWebWidgetStandard extends ZendeskWebWidget {
    constructor() {
        super();
        this.type = ZENDESK_WEB_WIDGET_TYPES.STANDARD;
    }

    init(closeCallback?: () => void) {
        this.onClose(() => {
            appHistoryReplaceWithSearchParams({ 'support-widget': null });
            if (typeof closeCallback === 'function') {
                closeCallback();
            }
        });
    };

    hide() {
        this.zE('messenger', 'hide');
    }

    show() {
        this.zE('messenger', 'show');
    }

    open() {
        this.zE('messenger', 'open');
    }

    close() {
        this.zE('messenger', 'close');
    }

    onClose(callback: () => void) {
        this.zE('messenger:on', 'close', callback);
    }

    setLocale(locale: string) {
        this.zE('messenger:set', 'locale', locale);
    }

    login(params: { token: string, uid: number }) {
        this.zE('messenger', 'loginUser', function(callback) {
            callback(params.token);
        });
    }

    setConversationTags(tags: string[]) {
        this.zE('messenger:set', 'conversationTags', tags);
    }

    setConversationFields(conversationFields?: IConversationField[]) {
        this.zE('messenger:set', 'conversationFields', conversationFields);
    }

    logout() {
        this.zE('messenger', 'logoutUser');
    }

    onUnreadMessages(callback: (count: number) => void) {
        this.zE('messenger:on', 'unreadMessages', callback);
    }

}

export default ZendeskWebWidgetStandard;
